<template>
  <div class="mx-auto max-w-3xl text-center">
    <div class="flex flex-wrap justify-center gap-x-2.5 gap-y-3">
      <button
        :class="{
          '!ring-2 !ring-gray-800': activatedTerms.length == 0,
        }"
        class="rounded-full pb-[0.438rem] pt-[0.438rem] sm:py-2 px-4 text-2xs !leading-tight text-gray-800 ring-1 ring-gray-800/70 transition-colors focus-visible:outline focus-visible:outline-offset-4 focus-visible:outline-blue-500 md:px-[1.125rem] md:py-[0.5625rem]"
        aria-label="Alles anzeigen, alle Fitler entfernen"
        @click="reset(), $emit('update', activatedTerms)"
      >
        Alle
      </button>
      <button
        v-for="(term, index) in terms"
        :key="index"
        :class="{
          '!ring-2 !ring-gray-800': activatedTerms.includes(term.title),
        }"
        class="rounded-full pb-[0.438rem] pt-[0.438rem] sm:py-2 px-4 text-2xs !leading-tight text-gray-800 ring-1 ring-gray-800/70 transition-colors focus-visible:outline focus-visible:outline-offset-4 focus-visible:outline-blue-500 md:px-[1.125rem] md:py-[0.5625rem]"
        :aria-label="`Filter ${term.title} ${
          activatedTerms.includes(term.title) ? 'deaktivieren' : 'aktivieren'
        }`"
        @click="toggleTerm(term.title), $emit('update', activatedTerms)"
      >
        {{ term.title }}
        <IconCross
          class="-mt-0.5 ml-1 hidden w-4"
          :class="{
            '!inline-block ': activatedTerms.includes(term.title),
          }"
        />
      </button>
    </div>
  </div>
</template>

<script setup>
import { useUrlSearchParams } from '@vueuse/core'

const props = defineProps({
  terms: { type: Array, default: () => [] },
  allowMultiSelect: { type: Boolean, default: false },
})

defineEmits(['update'])

const params = useUrlSearchParams('history')
const activatedTerms = ref([])

function toggleTerm(term) {
  // update value in url
  if (props.allowMultiSelect) {
    // toggle term in array
    activatedTerms.value = activatedTerms.value.includes(term)
      ? activatedTerms.value.filter((i) => i !== term)
      : [...activatedTerms.value, term]
    params.filters = activatedTerms.value.join('-')
  } else {
    activatedTerms.value = activatedTerms.value.includes(term) ? '' : [term]
    // update value in url
    params.filters = activatedTerms.value
  }
}
function reset() {
  params.filters = []
  activatedTerms.value = []
}
//On mount test if filter is set
onMounted(() => {
  if (params.filters) {
    toggleTerm(params.filters)
  }
})
</script>
